import { JetView } from 'webix-jet';
import { profile } from 'config/config';

/**
 * FilterMenuView class extends JetView to create a filter menu interface.
 */
export default class FilterMenuView extends JetView {
    /**
     * Configures the UI components of the filter menu.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        const partners = profile.Partners; // Retrieve partners from profile

        /**
         * Filters partners based on the provided partner ID.
         * @param {Object} partners - The partner object to filter.
         * @returns {boolean} True if the partner ID matches, otherwise false.
         */
        function filter_partners(partners) {
            return partners.id == id_partner;
        }

        var partner = partners.filter(filter_partners); // Filter partners

        const left = {
            margin: 10,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'Country',
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'), // Country label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [],
                            id: 'Countries',
                            on: {
                                onChange: function (data, obj) {
                                    var currentValue = this.getValue(); // Get current value
                                    if (currentValue.length > 0 && $$('Year').getValue().length > 0) {
                                        $$('button').enable(); // Enable button if both fields have values
                                    } else {
                                        $$('button').disable(); // Disable button otherwise
                                    }
                                },
                            },
                        },
                        {
                            view: 'richselect',
                            name: 'Year',
                            label: _('Año'), // Year label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                { name: '2017', value: '2017' },
                                { name: '2018', value: '2018' },
                                { name: '2019', value: '2019' },
                                { name: '2020', value: '2020' },
                                { name: '2021', value: '2021' },
                                { name: '2022', value: '2022' },
                            ],
                            id: 'Year',
                            on: {
                                onChange: function (data, obj) {
                                    var currentValue = this.getValue(); // Get current value
                                    if (currentValue.length > 0 && $$('Countries').getValue().length > 0) {
                                        $$('button').enable(); // Enable button if both fields have values
                                    } else {
                                        $$('button').disable(); // Disable button otherwise
                                    }
                                },
                            },
                        },
                    ],
                },
            ],
        };

        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Include left section
                },
            ],
        };

        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 },
                        {
                            view: 'button',
                            value: _('Limpiar'), // Clear button label
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear the form
                            },
                        },
                        {
                            view: 'button',
                            id: 'button',
                            value: _('Consultar'), // Consult button label
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            disabled: true, // Initially disabled
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                filterdata.Partner = partner[0].id; // Add partner ID to filter data
                                this.app.callEvent('control:filter', [
                                    filterdata, // Trigger filter event
                                ]);
                                $$('filterPopup').hide(); // Hide filter popup
                                $$('b1').collapse(); // Collapse the accordion
                            },
                        },
                    ],
                },
            ],
        };

        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Accordion header
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Include upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        const accordion_section3 = {
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Include upper section
            },
        };

        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Popup title
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close popup on icon click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3], // Include accordion section
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });

        return {
            view: 'form',
            type: 'clean',
            id: 'formFilter',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section // Show accordion section based on screen size
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up the partner countries.
     */
    init() {
        var vthis = this; // Reference to the current instance
        const _ = this.app.getService('locale')._; // Localization service
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        const partners = profile.Partners; // Retrieve partners from profile

        /**
         * Filters partners based on the provided partner ID.
         * @param {Object} partners - The partner object to filter.
         * @returns {boolean} True if the partner ID matches, otherwise false.
         */
        function filter_partners(partners) {
            return partners.id == id_partner;
        }

        var partner = partners.filter(filter_partners); // Filter partners
        partner[0].Countries.shift(); // Remove the first country from the list
        $$('Countries').define('options', partner[0].Countries); // Define options for the country select
        $$('Countries').refresh(); // Refresh the country select
    }
}

// FILE DOCUMENTED
